export const PALETTE = [
  "#29a383", // jade
  "#3e63dd", // indigo
  "#e54666", // crimson
  "#ab4aba", // plum
  "#f76b15", // orange
  "#00a2c7", // cyan
  "#d6409f", // pink
  "#46a758", // grass
  "#6e56cf", // violet
  "#d97706", // amber
  "#0090ff", // blue
  "#12a594", // teal
];

export function hashName(name: string): number {
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = ((hash << 5) - hash + name.charCodeAt(i)) | 0;
  }
  return Math.abs(hash);
}

export function colorForName(name: string): string {
  return PALETTE[hashName(name) % PALETTE.length];
}
